function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { Button, Loader } from "../../components";
import { NurtureAIFeedback, CurriculumBoundarySwitch, referencesText, NoMatchModal, CurriculumBoundaryReferences } from '../../components/nurtureAI';
import { SelectField, Textarea, TextInput } from "../../../core/form/fields";
import { FormGroup } from "reactstrap";
import { useSchoolConfig } from "../../hooks";
import { useSnackbar } from "notistack";
import { generateAssignment } from "./action";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { isPresent, pluralize, pusher } from "../../utils";
import { LEARNING_OBJECTIVES_OPTIONS, TONE_OPTIONS } from "./static";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { v4 as uuidv4 } from "uuid";
var NurtureAIAssignmentGenerator = function NurtureAIAssignmentGenerator(_ref) {
  var _channelOnboarding$da;
  var onSuggest = _ref.onSuggest,
    extras = _ref.extras;
  var STATES = {
    showHint: 1,
    working: 2,
    suggestion: 3
  };
  var LOADING_TEXTS = ['Making coffee', 'Generating Assessment', 'Almost done'];
  var _useState = useState(STATES.showHint),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    hint = _useState4[0],
    setHint = _useState4[1];
  var _useState5 = useState(3),
    _useState6 = _slicedToArray(_useState5, 2),
    learningObjectiveCount = _useState6[0],
    setLearningObjectiveCount = _useState6[1];
  var _useState7 = useState(250),
    _useState8 = _slicedToArray(_useState7, 2),
    descriptionLength = _useState8[0],
    setDescriptionLength = _useState8[1];
  var _useState9 = useState('exam_oriented'),
    _useState10 = _slicedToArray(_useState9, 2),
    tone = _useState10[0],
    setTone = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showAdvancedFields = _useState12[0],
    setShowAdvancedFields = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    suggestedName = _useState14[0],
    setSuggestedName = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    suggestedDescription = _useState16[0],
    setSuggestedDescription = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    suggestedLearningObjectives = _useState18[0],
    setSuggestedLearningObjectives = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    extraTexts = _useState20[0],
    setExtraTexts = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    references = _useState22[0],
    setReferences = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    aiRequestId = _useState24[0],
    setAiRequestId = _useState24[1];
  var _useState25 = useState(LOADING_TEXTS[0]),
    _useState26 = _slicedToArray(_useState25, 2),
    loadingText = _useState26[0],
    setLoadingText = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showNoMatchModal = _useState28[0],
    setShowNoMatchModal = _useState28[1];
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var _useSchoolConfig = useSchoolConfig(),
    learningObjectiveLabel = _useSchoolConfig.learningObjectiveLabel,
    channelOnboarding = _useSchoolConfig.channelOnboarding,
    curriculumBoundaryFeatureEnabled = _useSchoolConfig.curriculumBoundaryEnabled;
  var curriculumAttachment = channelOnboarding === null || channelOnboarding === void 0 || (_channelOnboarding$da = channelOnboarding.data) === null || _channelOnboarding$da === void 0 ? void 0 : _channelOnboarding$da.curriculum_attachment;
  var _useState29 = useState(isPresent(curriculumAttachment) && curriculumAttachment.embeddings_completed && curriculumBoundaryFeatureEnabled),
    _useState30 = _slicedToArray(_useState29, 2),
    curriculumBoundaryEnabled = _useState30[0],
    setCurriculumBoundaryEnabled = _useState30[1];
  var generateSuggestions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var intervalId, requestId, channelName, pusherChannel, requestBody, aggregatedData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setState(STATES.working);
            intervalId = toggleLoadingText();
            try {
              requestId = uuidv4().replace(/-/g, '');
              channelName = "assignmentGeneration-".concat(requestId);
              pusherChannel = pusher.subscribe(channelName);
              requestBody = _objectSpread({
                hint: hint,
                tone: tone,
                learning_objectives_count: learningObjectiveCount,
                description_length: descriptionLength,
                curriculumn_boundary_enabled: curriculumBoundaryEnabled,
                request_id: requestId,
                channel_name: channelName,
                run_in_background: true
              }, extras);
              generateAssignment(requestBody);

              // This does not return with the assignment data. The backend will process
              // this request asynchronously and send the assignment data via push. the front end
              // has to subscribe to the topic to expect the data, while this is happening in the
              // background, we want to keep ths user on the page and show them a loader
              // until the data is returned.
              // If the data is not returned after a timeout period the front end unsubscribe from the topic
              // and shows the teacher an error
              // We bind to the event before making the
              aggregatedData = '';
              pusherChannel.bind("assignmentData", function (data) {
                console.log('here 1');
                if (requestId !== data.request_id) return;
                console.log('here 2');
                aggregatedData += data.data;
                if (data.completed) {
                  // The data is sent in chunks, a completed key is marked as true once all the chunks has been sent
                  aggregatedData = JSON.parse(aggregatedData);
                  if (aggregatedData.error) {
                    enqueueSnackbar(aggregatedData.error, {
                      variant: 'error'
                    });
                    setState(STATES.showHint);
                  } else {
                    setSuggestedName(aggregatedData.title || aggregatedData.Title);
                    setSuggestedDescription(aggregatedData.description || aggregatedData.Description);
                    setSuggestedLearningObjectives(function (prevState) {
                      return aggregatedData.learningObjectives || aggregatedData.learning_objectives || aggregatedData['learning-objectives'] || aggregatedData['learning objectives'] || aggregatedData['Learning Objectives'] || aggregatedData['objectives'] || aggregatedData['Objectives'];
                    });
                    setAiRequestId(aggregatedData.id);
                    if (aggregatedData.no_curriculum_match) {
                      setShowNoMatchModal(true);
                      setState(STATES.showHint);
                    } else if (isPresent(aggregatedData.references)) {
                      setReferences(function () {
                        return aggregatedData.references;
                      });
                      setExtraTexts("References: pages ".concat(referencesText(aggregatedData.references), " from the uploaded document"));
                      setState(STATES.suggestion);
                    } else {
                      setState(STATES.suggestion);
                    }
                  }
                  clearInterval(intervalId);
                  pusher.unsubscribe(channelName);
                }
              });
            } catch (e) {
              enqueueSnackbar(e.message, {
                variant: 'error'
              });
              setState(STATES.showHint);
              clearInterval(intervalId);
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function generateSuggestions() {
      return _ref2.apply(this, arguments);
    };
  }();
  var toggleLoadingText = function toggleLoadingText() {
    setLoadingText(LOADING_TEXTS[0]);
    var currentIndex = 0;
    return setInterval(function () {
      if (currentIndex < LOADING_TEXTS.length - 1) {
        setLoadingText(LOADING_TEXTS[currentIndex + 1]);
        currentIndex += 1;
      }
    }, 3000);
  };
  var handleHintChange = function handleHintChange(e) {
    return setHint(e.target.value);
  };
  var handleDescriptionLengthChange = function handleDescriptionLengthChange(value) {
    return setDescriptionLength(value[1]);
  };
  var handleLearningObjectiveCountChanged = function handleLearningObjectiveCountChanged(e) {
    return setLearningObjectiveCount(e.target.value);
  };
  var handleToneChanged = function handleToneChanged(e) {
    return setTone(e.target.value);
  };
  var handleAdvancedFieldsToggle = function handleAdvancedFieldsToggle() {
    return setShowAdvancedFields(!showAdvancedFields);
  };
  var handleNameChange = function handleNameChange(e) {
    return setSuggestedName(e.target.value);
  };
  var handleDescriptionChange = function handleDescriptionChange(value) {
    return setSuggestedDescription(value);
  };
  var handleLearningObjectiveChange = function handleLearningObjectiveChange(index, e) {
    var objectives = _toConsumableArray(suggestedLearningObjectives);
    objectives[index] = e.target.value;
    setSuggestedLearningObjectives(function (prevState) {
      return objectives;
    });
  };
  var handleCurriculumBoundaryChanged = function handleCurriculumBoundaryChanged(e) {
    setCurriculumBoundaryEnabled(!curriculumBoundaryEnabled);
  };
  var handleSuggest = function handleSuggest() {
    if (typeof onSuggest === 'function' && window.confirm('This will overwrite your current changes do you wish to proceed')) {
      var result = {
        name: suggestedName,
        description: suggestedDescription,
        learningObjectives: suggestedLearningObjectives
      };
      onSuggest(result);
    }
  };
  var tryAgain = function tryAgain() {
    setState(STATES.showHint);
    setHint('');
    setExtraTexts('');
    setLearningObjectiveCount(3);
    setDescriptionLength(250);
    setTone('exam_oriented');
    setShowAdvancedFields(false);
    setShowNoMatchModal(false);
    setReferences([]);
  };
  return /*#__PURE__*/React.createElement("div", null, state === STATES.showHint && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "What you you like an assessment about?"), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Textarea, {
    className: "markdown",
    value: hint,
    rows: "7",
    onChange: handleHintChange
  }))), curriculumBoundaryFeatureEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-3 mt-4"
  }, /*#__PURE__*/React.createElement(CurriculumBoundarySwitch, {
    checked: curriculumBoundaryEnabled,
    onCurriculumBoundarySwitchChanged: handleCurriculumBoundaryChanged
  })), /*#__PURE__*/React.createElement(NoMatchModal, {
    show: showNoMatchModal,
    onContinue: function onContinue() {
      return setState(STATES.suggestion);
    },
    closeModal: function closeModal() {
      return setShowNoMatchModal(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-muted font-size-14 d-flex mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center cursor-pointer text-decoration-underline",
    onClick: handleAdvancedFieldsToggle
  }, /*#__PURE__*/React.createElement("span", null, "Advanced Settings"), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: showAdvancedFields ? faAngleDown : faAngleRight
  }))), showAdvancedFields && /*#__PURE__*/React.createElement("div", {
    className: "px-1 px-sm-3 py-2 bg-light rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(SelectField, {
    className: "default",
    label: "Number of ".concat(pluralize(learningObjectiveLabel)),
    options: LEARNING_OBJECTIVES_OPTIONS,
    value: learningObjectiveCount,
    onChange: handleLearningObjectiveCountChanged
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3 d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("div", null, "Description Length"), /*#__PURE__*/React.createElement("input", {
    value: descriptionLength,
    readOnly: true,
    style: {
      width: '50px'
    },
    className: "form-control p-1 font-size-12",
    type: "number"
  })), /*#__PURE__*/React.createElement(RangeSlider, {
    min: 100,
    className: "single-thumb",
    max: 600,
    thumbsDisabled: [true, false],
    defaultValue: [100, descriptionLength],
    rangeSlideDisabled: true,
    onInput: handleDescriptionLengthChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(SelectField, {
    className: "default",
    label: "Tone",
    options: TONE_OPTIONS,
    value: tone,
    onChange: handleToneChanged
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-grid border-top p-3 px-3 mt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !hint,
    onClick: generateSuggestions
  }, "Generate Assessment \u2728"))), state === STATES.working && /*#__PURE__*/React.createElement("div", {
    className: "py-4 px-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mb-3"
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "ring",
    loading: true,
    color: "#6CBDBF"
  })), /*#__PURE__*/React.createElement("div", {
    className: "font-size-15 text-muted mb-3 text-center"
  }, loadingText, "...")), state === STATES.suggestion && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Assessment Name",
    value: suggestedName,
    onChange: handleNameChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Description"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, {
    className: "markdown",
    value: suggestedDescription,
    rows: "7",
    onChange: handleDescriptionChange
  }))), (suggestedLearningObjectives === null || suggestedLearningObjectives === void 0 ? void 0 : suggestedLearningObjectives.length) > 0 && /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, learningObjectiveLabel), suggestedLearningObjectives === null || suggestedLearningObjectives === void 0 ? void 0 : suggestedLearningObjectives.map(function (value, index) {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextInput, {
      value: value,
      onChange: function onChange(e) {
        return handleLearningObjectiveChange(index, e);
      }
    }));
  }), !!extraTexts && curriculumBoundaryFeatureEnabled && references.length <= 0 && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-light p-2 mt-2 border-none"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: faInfoCircle
  }), /*#__PURE__*/React.createElement("small", null, extraTexts)), references.length > 0 && curriculumBoundaryFeatureEnabled && /*#__PURE__*/React.createElement(CurriculumBoundaryReferences, {
    extraTexts: extraTexts,
    references: references
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap justify-content-between align-items-center mt-5 px-3 py-3 border-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(NurtureAIFeedback, {
    aiRequestId: aiRequestId
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    color: "white",
    className: "me-2",
    onClick: tryAgain
  }, "Try again"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSuggest
  }, "Use Suggestion")))));
};
NurtureAIAssignmentGenerator.defaultProps = {
  onSuggest: null,
  extras: {}
};
export default NurtureAIAssignmentGenerator;